import React from 'react';
import ContentAlert from './ContentAlert';
import { TitleAlert } from './TitleAlert';
import { AlertVariant } from './ErrorAlertContainer';

type ErrorAlertProps = {
  titleText?: string;
  contentText?: React.ReactNode[] | React.ReactNode;
  dismissable: boolean;
  onDismissed?: () => void;
  variant?: AlertVariant;
};

export default function ErrorAlert(props: ErrorAlertProps) {
  if (!props.titleText) {
    return props.contentText ? (
      <ContentAlert
        {...props}
        contentText={
          Array.isArray(props.contentText)
            ? props.contentText[0]
            : props.contentText
        }
      />
    ) : null;
  } else {
    return <TitleAlert {...props} titleText={props.titleText} />;
  }
}
